import drawingLayerTypes from 'helpers/enums/drawingLayerTypes'
import layerActionTypes from 'components/drawit/helpers/layerActionTypes'

const TEXT_PADDING = 4 //padding from textarea
const TEXT_BORDER = 2 //border from textarea

function getList(actions) {
	return new Promise(res => {
		const list = actions.filter(action => action.type === drawingLayerTypes.TEXT)
			.reduce((accumulator, element) => {
				accumulator[element.index]=element
				return accumulator
			}, [])
			.filter(element => element.actionType !== layerActionTypes.ERASE)
		res(list)
	})
}

function createLines(text) {
	const lines = []
	let currentLine = ''
	for (const char of text) {
		const charCode = char.charCodeAt(0)
		if (charCode === 13 || charCode === 10) {
			lines.push(currentLine)
			currentLine = ''
		} else {
			currentLine += char
		}
	}
	if (currentLine) {
		lines.push(currentLine)
	}
	return lines
}

function createWords(text) {
	const words = []
	let currentWord = '', lastCharCode = -1, currentCharCode
	for (const char of text) {
		currentCharCode = char.charCodeAt(0)
		if (currentCharCode !== 32 && lastCharCode === 32) {
			words.push(currentWord)
			currentWord = char
		} else {
			currentWord += char
		}
		lastCharCode = currentCharCode
	}
	words.push(currentWord)
	return words
}

function calculateRemainder(word) {
	if (!word.length || word.charCodeAt(0) === 32) {
		return ''
	}
	return word

}

function splitWord(word, maxWidth, ctx) {
	const lines = []
	let currentText = ''
	for (const char of word) {
		if (getTextWidth(currentText + char, ctx) > maxWidth) {
			lines.push(currentText)
			currentText = ''
		}
		currentText += char
	}
	return {
		lines,
		remainder: calculateRemainder(currentText),
	}
}

function stripText(text) {
	return text.split(' ')[0]
}

function getTextWidth(text, ctx) {
	const metrics = ctx.measureText(text)
	return metrics.width
}

function splitLine(line, maxWidth, ctx) {
	const words = createWords(line)
	let lines = []
	let currentLineString = ''
	words.forEach(word => {
		if (getTextWidth(currentLineString + stripText(word), ctx) > maxWidth) {
			if (currentLineString !== '') {
				lines.push(currentLineString)
			}
			if (getTextWidth(word, ctx) > maxWidth) {
				const splitWordData = splitWord(word, maxWidth, ctx)
				lines = [
					...lines,
					...splitWordData.lines,
				]
				currentLineString = splitWordData.remainder
			} else {
				currentLineString = word
			}
		} else {
			currentLineString += word
		}
	})

	// We are adding an extra line in two cases:
	// if there is a remaining text
	// or if there are no words in the line which means it's a line with only a carriage return.
	if (currentLineString || (words.length === 1 && words[0] === '')) {
		lines.push(currentLineString)
	}
	return lines
}

function createTextLines(text, box, ctx) {
	let lines = createLines(text)
	lines = lines.reduce((accumulator, line) => {
		accumulator = [
			...accumulator,
			...splitLine(line, box.right - box.left - TEXT_PADDING - TEXT_BORDER, ctx),
		]
		return accumulator
	}, [])
	return lines
}

function drawTexts(textList, width, height) {
	return new Promise(res => {
		const canvas = document.createElement('canvas')
		canvas.width = width
		canvas.height = height
		const ctx = canvas.getContext('2d')
		textList.forEach(textData => {
			ctx.save()
			const boundingBox = textData.boundingBox
			ctx.rect(boundingBox.left, boundingBox.top, boundingBox.right - boundingBox.left, boundingBox.bottom - boundingBox.top)
			ctx.clip()
			const fontSize = textData.fontSize
			ctx.font = fontSize + 'px sans-serif'
			ctx.fillStyle = textData.fontColor
			ctx.textBaseline='top'
			const lineHeight = Math.ceil(fontSize)
			let y = fontSize * 10 / 140 + boundingBox.top - textData.scrollTop
			const x = boundingBox.left + TEXT_PADDING / 2 + TEXT_BORDER / 2
			const textLines = createTextLines(textData.text, boundingBox, ctx)
			textLines.forEach(text => {
				ctx.fillText(text, x, y)
				y += lineHeight
			})
			ctx.restore()
		})
		res(canvas)
	})
}

function saveTexts(actions, width, height) {
	return new Promise(res => {
		getList(actions)
			.then(list => drawTexts(list, width, height))
			.then(res)
	})
}

export default saveTexts
